import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/non-controlled-hitter-stacking/actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class BattingOrder extends Component {
    onChange(priority, isChecked) {
        this.props.dispatch(Action.setBattingOrderForStackNumber({[priority]: isChecked}, this.props.stackNumber));
    }

    render() {
        const {stackNumber, stacking} = this.props;
        const order = stacking.getBattingOrderByStackNumber(stackNumber);

        return (
            <div className="pt5">
                <strong className="filter-sub-title">Batting order from:</strong>
                <div className="form-inline gap-row-5">
                    {Object.keys(order).map((priority) => {
                        let isChecked = order[priority];
                        return (
                            <InputCheckbox
                                key={priority}
                                label={priority}
                                checked={isChecked}
                                onChange={(value) => ::this.onChange(priority, value)}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {nonControlledHitterStacking} = state;
    return {
        stacking: nonControlledHitterStacking.settings,
    };
}

export default connect(mapStatesToProps)(BattingOrder);
